module.exports = __webpack_public_path__ + "img/browsers.7b6b85e4.png";